var SELECT_ALL_ITEMS = 'All';
export { SELECT_ALL_ITEMS };